export default [
  "AbrilFatface",
  "AlexBrush",
  "Allura",
  "Blackjack",
  "ChunkFive",
  "Droid Sans",
  "FKGrotesk",
  "GrandHotel",
  "GreatVibes",
  "JakartaSans",
  "JosefinSans",
  "Jost",
  "KaushanScript",
  "Lato",
  "LeagueGothic",
  "LeagueSpartan",
  "Montserrat",
  "Open Sans",
  "Oswald",
  "Pacifico",
  "PlayfairDisplay",
  "Poppins",
  "Roboto",
  "RobotoMono",
  "SEASRN__",
  "Sofia",
  "Windsong",
  "WorkSans",
];
